import script from "./LongInsureDispatchDrawer.vue?vue&type=script&lang=ts&setup=true"
export * from "./LongInsureDispatchDrawer.vue?vue&type=script&lang=ts&setup=true"

import "./LongInsureDispatchDrawer.vue?vue&type=style&index=0&id=417605ad&lang=stylus&scoped=true"

import exportComponent from "C:\\work\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-417605ad"]])

export default __exports__